<template>
  <v-container fluid>
    <!-- Tabella -->
    <v-data-table
      v-if="data_table === true"
      :headers="headers"
      fixed-header
      :items="veicoli.filter((v) => v.validita == true).reverse()"
      :items-per-page="10"
      item-key="id_macchina"
      class="elevation-1"
      calculate-widths
      height="60vh"
    >
      <!-- Intestazione tabella -->
      <template v-slot:top>
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Veicoli
            <v-icon color="white"> mdi-truck </v-icon>
          </v-toolbar-title>
          <!-- Aggiungi veicolo -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="nuovoVeicolo()"
                class="ml-auto mr-n15"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Nuovo Veicolo</span>
          </v-tooltip>
          <!-- Visualizza filtri -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                v-bind="attrs"
                v-on="on"
                small
                @click="filters == true ? (filters = false) : (filters = true)"
              >
                <v-icon color="purple"> mdi-filter </v-icon>
              </v-btn>
            </template>
            <span v-if="filters == false">Visualizza Filtri</span>
            <span v-else>Nascondi Filtri</span>
          </v-tooltip>
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="goBack()"
                class="ml-15"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Vai alla Dashboard</span>
          </v-tooltip>
        </v-toolbar>
        <!-- Row Filtri -->
        <v-row justify="center" v-if="filters === true" class="ma-1">
          <v-col cols="3" md="2">
            <v-autocomplete
              @change="filtra"
              label="Tipo"
              v-model="tipo_filter"
              dense
              hide-details
              :items="items_tipo"
              class="mt-5"
              item-text="des"
              item-value="id_tabella"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              v-model="targa_filter"
              label="Targa"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-autocomplete
              @change="filtra"
              label="Marca"
              v-model="marca_filter"
              dense
              hide-details
              :items="items_marca"
              class="mt-5"
              item-text="des"
              item-value="id_tabella"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-autocomplete
              @change="filtra"
              label="Modello"
              v-model="modello_filter"
              dense
              hide-details
              :items="items_modello"
              class="mt-5"
              item-text="des"
              item-value="id_tabella"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              v-model="telaio_filter"
              label="Telaio"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-autocomplete
              @change="filtra"
              label="Azienda"
              v-model="azienda_filter"
              dense
              hide-details
              :items="items_azienda"
              class="mt-5"
              item-text="des"
              item-value="id_tabella"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              type="number"
              v-model.number="potenza_filter"
              label="Potenza"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-autocomplete
              @change="filtra"
              label="Alimentazione"
              v-model="alimentazione_filter"
              dense
              hide-details
              :items="items_alimentazione"
              class="mt-5"
              item-text="des"
              item-value="id_tabella"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-autocomplete
              @change="filtra"
              label="Patente"
              v-model="patente_filter"
              dense
              hide-details
              :items="items_patente"
              class="mt-5"
              item-text="descrizione"
              item-value="id_abilitazione"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              type="number"
              v-model.number="massa_filter"
              label="Massa"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              type="number"
              v-model.number="massa_rimorchio_filter"
              label="Massa Rimorchio"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              type="number"
              v-model.number="massa_pieno_carico_filter"
              label="Massa Pieno Carico"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              type="number"
              v-model.number="lunghezza_filter"
              label="Lunghezza"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              type="number"
              v-model.number="larghezza_filter"
              label="Larghezza"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="3" md="2">
            <v-text-field
              @change="filtra"
              type="number"
              v-model.number="altezza_filter"
              label="Altezza"
              dense
              hide-details
              class="mt-5"
            />
          </v-col>
          <v-col cols="1">
            <!-- Reset filtri -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mt-5"
                  v-bind="attrs"
                  v-on="on"
                  small
                  @click="resetFiltri()"
                >
                  <v-icon color="error"> mdi-filter-off </v-icon>
                </v-btn>
              </template>
              <span>Resetta Filtri</span>
            </v-tooltip>
          </v-col>

          <v-col cols="3" md="2">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="filtra()"
                  class="mt-4 success"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Filtra</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </template>

      <!-- Pulsante edit -->
      <template v-slot:[`item.edit`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              @click="
                selectItem(item);
                data_table = false;
              "
            >
              <v-icon color="primary">mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Dettagli</span>
        </v-tooltip>
      </template>
      <!-- Tipo -->
      <template v-slot:[`item.id_tipo`]="{ item }">
        {{
          items_tipo.filter((t) => t.id_tabella === item.id_tipo).length > 0
            ? items_tipo.filter((t) => t.id_tabella === item.id_tipo)[0].des
            : "N/D"
        }}
      </template>
      <!-- Azienda -->
      <template v-slot:[`item.id_azienda`]="{ item }">
        {{
          items_azienda.filter((t) => t.id_tabella === item.id_azienda).length >
          0
            ? items_azienda.filter((t) => t.id_tabella === item.id_azienda)[0]
                .des
            : "N/D"
        }}
      </template>
      <!-- Marca -->
      <template v-slot:[`item.id_marca`]="{ item }">
        {{
          items_marca.filter((t) => t.id_tabella === item.id_marca).length > 0
            ? items_marca.filter((t) => t.id_tabella === item.id_marca)[0].des
            : "N/D"
        }}
      </template>
      <!-- Modello -->
      <template v-slot:[`item.modello`]="{ item }">
        {{
          items_modello.filter((t) => t.id_tabella == item.modello).length > 0
            ? items_modello.filter((t) => t.id_tabella == item.modello)[0].des
            : "N/D"
        }}
      </template>
      <!-- Alimentazione -->
      <template v-slot:[`item.id_alimentazione`]="{ item }">
        {{
          items_alimentazione.filter(
            (t) => t.id_tabella === item.id_alimentazione
          ).length > 0
            ? items_alimentazione.filter(
                (t) => t.id_tabella === item.id_alimentazione
              )[0].des
            : "N/D"
        }}
      </template>
      <!-- Ragno -->
      <template v-slot:[`item.ragno`]="{ item }">
        <v-icon :color="item.ragno == 1 ? 'success' : 'error'">{{
          item.ragno == 1 ? "mdi-check-circle" : "mdi-close-circle"
        }}</v-icon>
      </template>
      <!-- Cassoni Associati -->
      <template v-slot:[`item.macchina_associazioni`]="{ item }">
        <v-btn
          small
          @click="
            selectItem(item);
            data_table = false;
            tab = 1;
          "
        >
          <v-icon
            :color="item.macchina_associazioni != null ? 'success' : 'error'"
          >
            mdi-truck-trailer</v-icon
          >
        </v-btn>
      </template>
      <!-- Pulsante rimuovi -->
      <template v-slot:[`item.delete`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              small
              @click="
                selectItem(item);
                delete_dialog = true;
              "
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Elimina</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Create/Edit template -->
    <template v-if="data_table === false">
      <v-card min-height="70vh" class="mt-5">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text">
            Veicoli
            <v-icon color="white"> mdi-truck </v-icon>
          </v-toolbar-title>
          <v-spacer />
          <!-- Salva veicolo -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-13"
                @click="salvaVeicolo()"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
          <v-spacer />
          <!-- Torna indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto"
                @click="resetTab()"
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Indietro</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <!------- Tabs ------->
          <v-tabs
            v-if="selected_item.id_macchina !== -1"
            v-model="tab"
            align-with-title
          >
            <v-tabs-slider color="transparent"></v-tabs-slider>
            <v-tab active-class="sfondoStandard" class="py-0 my-0">
              Generale
              <v-icon class="ml-1"> mdi-truck </v-icon>
            </v-tab>
            <v-tab active-class="sfondoStandard" class="py-0 my-0">
              Cassoni
              <v-icon class="ml-1"> mdi-truck-trailer </v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item>
              <!--    GENERALE     -->
              <QLGenerale
                ref="createEdit"
                :selected_item="selected_item"
                :items_tipo="items_tipo"
                :items_marca="items_marca"
                :items_modello="items_modello"
                :items_azienda="items_azienda"
                :items_alimentazione="items_alimentazione"
                :items_patente="items_patente"
                @aggiornaAutocomplete="aggiornaAutocomplete()"
              />
            </v-tab-item>
            <v-tab-item>
              <!--    CASSONI     -->
              <QLCassoni :veicolo_associazione="selected_item" />
            </v-tab-item>
          </v-tabs-items>
          <!------- /Tabs ------->
        </v-card-text>
      </v-card>
    </template>
    <!-- Dialog Delete -->
    <v-dialog persistent v-model="delete_dialog" max-width="700">
      <v-card min-height="30vh">
        <v-toolbar color="indigo" dense class="rounded rounded-b-0">
          <v-toolbar-title class="white--text"> Elimina </v-toolbar-title>
          <v-spacer />
          <!-- Conferma eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-auto mr-5"
                @click="
                  selected_item.validita = 0;
                  salvaVeicolo();
                "
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer />
          <!-- Annulla eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                small
                @click="delete_dialog = false"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <br />
        <v-card-text class="mt-10">
          <p class="black--text">
            Sei sicuro di voler eliminare il veicolo
            {{
              items_modello.filter(
                (t) => t.id_tabella === parseInt(selected_item.modello)
              ).length > 0
                ? items_modello.filter(
                    (t) => t.id_tabella === parseInt(selected_item.modello)
                  )[0].des
                : ""
            }}?
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>
<script>
import QLGenerale from "./QLCOMPONENTS/QLVeicoli/QLGeneraleVeicoli.vue";
import QLCassoni from "./QLCOMPONENTS/QLVeicoli/QLCassoniComponent.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Veicolo {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }
  // Metodo per resettare tutti i campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_macchina_extra", default_val: -1 },
      { nome: "id_macchina", default_val: -1 },
      { nome: "assetId", default_val: null },
      { nome: "codice_interno", default_val: null },
      { nome: "id_tipo", default_val: null },
      { nome: "targa", default_val: "" },
      { nome: "ragno", default_val: 0 },
      { nome: "id_marca", default_val: null },
      { nome: "modello", default_val: null },
      { nome: "telaio", default_val: "" },
      { nome: "id_azienda", default_val: "" },
      { nome: "immatricolazione", default_val: null },
      { nome: "scadenza_assicurazione", default_val: null },
      { nome: "scadenza_tassa_circolazione", default_val: null },
      { nome: "potenza", default_val: null },
      { nome: "id_alimentazione", default_val: null },
      { nome: "id_tipo_patente", default_val: null },
      { nome: "massa", default_val: null },
      { nome: "um_massa", default_val: 388 },
      { nome: "massa_rimorchio", default_val: null },
      { nome: "um_massa_rimorchio", default_val: 388 },
      { nome: "massa_pieno_carico", default_val: null },
      { nome: "um_massa_pieno_carico", default_val: 388 },
      { nome: "lunghezza", default_val: null },
      { nome: "larghezza", default_val: null },
      { nome: "altezza", default_val: null },
      { nome: "note", default_val: "" },
      { nome: "priorita", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "QLVeicoli",
  components: {
    QLGenerale,
    QLCassoni,
    SnackbarQV,
  },
  data() {
    return {
      // Variabili d'appoggio
      tab: 0,
      overlay: false,
      // ARRAY
      // Array veicoli filtrati
      veicoli: [],
      // Array veicoli totali
      tot_veicoli: [],
      // Array autocomplete
      items_tipo: [],
      items_marca: [],
      items_modello: [],
      items_azienda: [],
      items_alimentazione: [],
      items_patente: [],
      // Variabili dialog
      delete_dialog: false,
      // Variabili filtri
      tipo_filter: "",
      targa_filter: "",
      marca_filter: "",
      modello_filter: "",
      telaio_filter: "",
      azienda_filter: "",
      potenza_filter: "",
      alimentazione_filter: "",
      patente_filter: "",
      massa_filter: null,
      massa_rimorchio_filter: null,
      massa_pieno_carico_filter: null,
      lunghezza_filter: null,
      larghezza_filter: null,
      altezza_filter: null,
      // Visibilita tabella
      data_table: true,
      // Veicolo selezionato
      selected_item: new Veicolo(),
      // Boolean visualizza filtri
      filters: false,
      // Headers Tabella
      headers: [
        {
          text: "Modifica",
          value: "edit",
          filterable: false,
          sortable: false,
        },
        {
          text: "Codice",
          value: "codice_interno",
          filterable: false,
          sortable: false,
        },
        {
          text: "Targa",
          value: "targa",
          filterable: false,
          sortable: false,
        },
        {
          text: "Tipo",
          value: "id_tipo",
          filterable: false,
          sortable: false,
        },
        {
          text: "Priorità",
          value: "priorita",
          filterable: false,
          sortable: false,
        },
        {
          text: "Azienda",
          value: "id_azienda",
          filterable: false,
          sortable: false,
        },
        {
          text: "Marca",
          value: "id_marca",
          filterable: false,
          sortable: false,
        },
        {
          text: "Modello",
          value: "modello",
          filterable: false,
          sortable: false,
        },
        {
          text: "Alimentazione",
          value: "id_alimentazione",
          filterable: false,
          sortable: false,
        },
        {
          text: "Ragno",
          value: "ragno",
          filterable: false,
          sortable: false,
        },
        {
          text: "Associato",
          value: "macchina_associazioni",
          filterable: false,
          sortable: false,
        },
        {
          text: "Elimina",
          value: "delete",
          filterable: false,
          sortable: false,
        },
      ],
    };
  },
  watch: {
    variabile: {
      immediate: true,

      handler() {},
    },
  },

  methods: {
    // metodo per rimettere la tab Generale quando
    // l'utente torna da cassoni alla tabella dei veicoli
    resetTab() {
      this.data_table = true;
      this.tab = 0;
    },

    // Veicolo selezionato
    selectItem(item) {
      this.selected_item = new Veicolo(JSON.parse(JSON.stringify(item)));
      console.log(item);
    },

    // Autocomplete
    aggiornaAutocomplete() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'EG_TIPO_VEICOLO', 'EG_ALIMENTAZIONE_VEICOLO','EG_MARCA_VEICOLO', 'EG_MODELLO_VEICOLO', 'EG_AZIENDA_VEICOLO'",
          filter: `validita = 1`,
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.items_tipo = res.data.EG_TIPO_VEICOLO
              ? res.data.EG_TIPO_VEICOLO
              : [];
            this.items_marca = res.data.EG_MARCA_VEICOLO
              ? res.data.EG_MARCA_VEICOLO
              : [];
            this.items_modello = res.data.EG_MODELLO_VEICOLO
              ? res.data.EG_MODELLO_VEICOLO
              : [];
            this.items_azienda = res.data.EG_AZIENDA_VEICOLO
              ? res.data.EG_AZIENDA_VEICOLO
              : [];
            this.items_alimentazione = res.data.EG_ALIMENTAZIONE_VEICOLO
              ? res.data.EG_ALIMENTAZIONE_VEICOLO
              : [];
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
          // console.table(this.items_tipo);
        })
        .catch((e) => {
          console.error(e);
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
      let getpatenti = {
        controller: "logistic",
        method: "POST",
        richiesta: {
          action: "getabilitazioni",
          token: localStorage.getItem("user_token"),
          filter: `validita = 1`,
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getpatenti).then((res) => {
        this.overlay = false;
        if (res.status == 200) {
          this.items_patente = res.data.result.length != 0 ? res.data.result : [];
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        }
      });
    },
    // Nuovo Veicolo
    nuovoVeicolo() {
      this.data_table = false;
      this.selected_item = new Veicolo();
    },
    // Crea/Modifica/elimina veicolo
    salvaVeicolo() {
      if (
        this.selected_item.codice_interno == null ||
        this.selected_item.codice_interno == ""
      ) {
        return this.$refs.SnackbarQV.print(
          "orange",
          "Codice veicolo non valido."
        );
      }
      if (
        this.selected_item.immatricolazione == null ||
        this.selected_item.immatricolazione == ""
      ) {
        return this.$refs.SnackbarQV.print(
          "orange",
          "Data immatricolazione non valida"
        );
      }
      if (
        this.selected_item.scadenza_assicurazione == null ||
        this.selected_item.scadenza_assicurazione == ""
      ) {
        return this.$refs.SnackbarQV.print(
          "orange",
          "Data scadenza assicurazione non valida"
        );
      }
      if (
        this.selected_item.scadenza_tassa_circolazione == null ||
        this.selected_item.scadenza_tassa_circolazione == ""
      ) {
        return this.$refs.SnackbarQV.print(
          "orange",
          "Data scadenza bollo non valida"
        );
      }
      let request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setmacchina",
          token: localStorage.getItem("user_token"),
          tabella: [
            {
              id_macchina: this.selected_item.id_macchina,
              id_tipo_get_macchina: 33570,
            },
          ],
          extra: [this.selected_item],
        },
      };
      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status == 200) {
            this.getMacchine();
            this.$refs.SnackbarQV.print(
              "success",
              "Veicolo salvato correttamente."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          console.error(err);
        });
      this.filtra();
      this.data_table = true;
      this.tab = 0;
      this.delete_dialog = false;
    },
    // prendi i veicoli dal db
    getMacchine() {
      const getlistamacchine = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getlistamacchine",
          token: localStorage.getItem("user_token"),
          idmacchina: "macchina.id_macchina",
          val_txt: "MOTRICI",
          filter: "validita=1",
        },
      };
      this.overlay = true;
      this.$store.dispatch("api", getlistamacchine).then((res) => {
        this.overlay = false;
        if (res.status === 200) {
          // console.log(res.data);
          this.veicoli = [];
          this.tot_veicoli = [];
          res.data.macchine.forEach((e) => {
            if (e.extra.length > 0) {
              let v = e.extra[0];
              v.macchina_associazioni = e.macchina_associazioni;
              this.tot_veicoli.push(v);
            }
          });
          this.veicoli = Array.from(this.tot_veicoli.reverse());
          // console.table(this.tot_veicoli);
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Errore di comunicazione col server, non è stato possibile aggiornare i dati.`
          );
        }
      });
    },
    // Filtri
    filtra() {
      /* Preparo un array temporaneo in cui
       * collezionare i veicoli filtrati */
      let veicoli_tmp = [];
      this.tot_veicoli.forEach((v) => {
        veicoli_tmp.push(new Veicolo(v));
      });

      // Filtro per tipo
      if (this.tipo_filter !== "" && typeof this.tipo_filter !== "object") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (elem.id_tipo == this.tipo_filter) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      //Filtro per targa
      if (this.targa_filter != "") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (
            elem.targa.toUpperCase().includes(this.targa_filter.toUpperCase())
          ) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per marca
      if (this.marca_filter !== "" && typeof this.marca_filter !== "object") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (elem.id_marca == this.marca_filter) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per modello
      if (
        this.modello_filter !== "" &&
        typeof this.modello_filter !== "object"
      ) {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (elem.modello == this.modello_filter) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      //Filtro per telaio
      if (this.telaio_filter != "") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (
            elem.telaio.toUpperCase().includes(this.telaio_filter.toUpperCase())
          ) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per azienda
      if (
        this.azienda_filter !== "" &&
        typeof this.azienda_filter !== "object"
      ) {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (elem.id_azienda == this.azienda_filter) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per potenza
      if (this.potenza_filter != null && this.potenza_filter != "") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (JSON.stringify(elem.potenza).includes(this.potenza_filter)) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per alimentazione
      if (
        this.alimentazione_filter !== "" &&
        typeof this.alimentazione_filter !== "object"
      ) {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (elem.id_alimentazione == this.alimentazione_filter) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per patente
      if (
        this.patente_filter !== "" &&
        typeof this.patente_filter !== "object"
      ) {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (elem.id_tipo_patente == this.patente_filter) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per massa
      if (this.massa_filter != null && this.massa_filter != "") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (JSON.stringify(elem.massa).includes(this.massa_filter)) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per massa_rimorchio
      if (
        this.massa_rimorchio_filter != null &&
        this.massa_rimorchio_filter != ""
      ) {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (
            JSON.stringify(elem.massa_rimorchio).includes(
              this.massa_rimorchio_filter
            )
          ) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per massa_pieno_carico
      if (
        this.massa_pieno_carico_filter != null &&
        this.massa_pieno_carico_filter != ""
      ) {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (
            JSON.stringify(elem.massa_pieno_carico).includes(
              this.massa_pieno_carico_filter
            )
          ) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per lunghezza
      if (this.lunghezza_filter != null && this.lunghezza_filter != "") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (JSON.stringify(elem.lunghezza).includes(this.lunghezza_filter)) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per larghezza
      if (this.larghezza_filter != null && this.larghezza_filter != "") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (JSON.stringify(elem.larghezza).includes(this.larghezza_filter)) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Filtro per altezza
      if (this.altezza_filter != null && this.altezza_filter != "") {
        let res = [];
        veicoli_tmp.forEach((elem) => {
          if (JSON.stringify(elem.altezza).includes(this.altezza_filter)) {
            res.push(new Veicolo(elem));
          }
        });
        veicoli_tmp = [];
        res.forEach((e) => {
          veicoli_tmp.push(new Veicolo(e));
        });
      }
      // Ricostruisco gli articoli visualizzati in base ai filtri aggiunti.
      (this.veicoli = []), (this.veicoli = Array.from(veicoli_tmp));
    },
    resetFiltri() {
      this.tipo_filter = "";
      this.targa_filter = "";
      this.marca_filter = "";
      this.modello_filter = "";
      this.telaio_filter = "";
      this.azienda_filter = "";
      this.immatricolazione_filter = "";
      this.potenza_filter = null;
      this.alimentazione_filter = "";
      this.patente_filter = "";
      this.massa_filter = null;
      this.massa_rimorchio_filter = null;
      this.massa_pieno_carico_filter = null;
      this.lunghezza_filter = null;
      this.larghezza_filter = null;
      this.altezza_filter = null;
      this.filtra();
    },
    // Torna al menu radiale
    goBack() {
      this.$router.push("/home/quicklogistic");
    },
  },
  created() {},
  mounted() {
    this.aggiornaAutocomplete();
    this.getMacchine();
  },
};
</script>
<style scoped>
</style>